import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-polylinedecorator";
import type { LatLngExpression } from "leaflet";

type PolylineArrowsProps = {
  positions: LatLngExpression[];
  color?: string;
  weight?: number; // Line weight to match arrow size
};

/**
 * Component to add directional arrows to polylines
 */
export function PolylineArrows({ positions, color = "#007AFF", weight = 4 }: PolylineArrowsProps) {
  const map = useMap();

  useEffect(() => {
    if (!positions || positions.length < 2) return;

    try {
      // Arrow size based on line weight
      const arrowSize = Math.max(10, weight * 2.5);

      // Different arrow styles for solid vs dashed lines
      const patterns = [
        // For solid lines: filled arrows matching line weight
        {
          offset: "15%",
          repeat: "20%",
          symbol: L.Symbol.arrowHead({
            pixelSize: arrowSize,
            polygon: false,
            pathOptions: {
              stroke: true,
              weight: weight,
              color: color,
              fillOpacity: 0.8,
            },
          }),
        },
      ];

      // Create decorator
      const decorator = new L.PolylineDecorator(positions, {
        patterns: patterns,
      });

      decorator.addTo(map);

      return () => {
        map.removeLayer(decorator);
      };
    } catch (error) {
      console.error("PolylineArrows error:", error);
    }
  }, [map, positions, color, weight]);

  return null;
}
